import useResizeObserver from "@react-hook/resize-observer";
import { useRef, useState } from "react";

export const useElementSize = <E extends Element = HTMLDivElement>() => {
  const ref = useRef<E>(null);
  const [size, setSize] = useState<DOMRectReadOnly>();

  useResizeObserver(ref, (element) => {
    setSize(element.contentRect);
  });

  return {
    ref,
    size,
  };
};
